import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import DocSection, {
  DocSubsection,
  DocNote,
  DocStep,
  DocImage,
} from "../components/DocSection";

const GettingStarted = () => {
  const { t } = useTranslation();

  return (
    <DocSection id="getting-started" title={t("docs.gettingStarted.title")}>
      {/* Welcome Section */}
      <DocSubsection id="welcome" title={t("docs.gettingStarted.welcome")}>
        <p>{t("docs.gettingStarted.welcomeDesc")}</p>

        <h4>{t("docs.gettingStarted.whatIsTitle")}</h4>
        <p>{t("docs.gettingStarted.whatIsDesc")}</p>

        <DocImage
          src="/docs/home-overview.png"
          alt="OncoEvida Home Page Overview"
          caption={t("docs.images.homeOverview")}
        />

        <h4>{t("docs.gettingStarted.keyCapabilities")}</h4>
        <ul>
          <li>
            <strong>{t("docs.gettingStarted.capability1Title")}:</strong>{" "}
            {t("docs.gettingStarted.capability1Desc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.capability2Title")}:</strong>{" "}
            {t("docs.gettingStarted.capability2Desc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.capability3Title")}:</strong>{" "}
            {t("docs.gettingStarted.capability3Desc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.capability4Title")}:</strong>{" "}
            {t("docs.gettingStarted.capability4Desc")}
          </li>
        </ul>
      </DocSubsection>

      {/* Navigation Section */}
      <DocSubsection id="navigation" title={t("docs.gettingStarted.navigation")}>
        <p>{t("docs.gettingStarted.navigationDesc")}</p>

        <DocImage
          src="/docs/navbar-navigation.png"
          alt="Navigation Bar with Menu Items"
          caption={t("docs.images.navbarNavigation")}
        />

        <h4>{t("docs.gettingStarted.mainMenuTitle")}</h4>
        <ul>
          <li>
            <strong>{t("docs.gettingStarted.menuHome")}:</strong>{" "}
            {t("docs.gettingStarted.menuHomeDesc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.menuDatasets")}:</strong>{" "}
            {t("docs.gettingStarted.menuDatasetsDesc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.menuCreateChart")}:</strong>{" "}
            {t("docs.gettingStarted.menuCreateChartDesc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.menuDashboard")}:</strong>{" "}
            {t("docs.gettingStarted.menuDashboardDesc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.menuRecommendations")}:</strong>{" "}
            {t("docs.gettingStarted.menuRecommendationsDesc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.menuSettings")}:</strong>{" "}
            {t("docs.gettingStarted.menuSettingsDesc")}
          </li>
        </ul>

        <DocImage
          src="/docs/settings-preferences.png"
          alt="Settings Page - Language and Theme Preferences"
          caption={t("docs.images.settingsPreferences")}
        />

        <h4>{t("docs.gettingStarted.languageThemeTitle")}</h4>
        <p>{t("docs.gettingStarted.languageThemeDesc")}</p>
        <ul>
          <li>
            <strong>{t("docs.gettingStarted.languageTitle")}:</strong>{" "}
            {t("docs.gettingStarted.languageDesc")}
          </li>
          <li>
            <strong>{t("docs.gettingStarted.themeTitle")}:</strong>{" "}
            {t("docs.gettingStarted.themeDesc")}
          </li>
        </ul>
      </DocSubsection>

      {/* Quick Start Section */}
      <DocSubsection id="quick-start" title={t("docs.gettingStarted.quickStart")}>
        <p>{t("docs.gettingStarted.quickStartDesc")}</p>

        <div className="doc-steps">
          <DocStep number="1" title={t("docs.gettingStarted.step1Title")}>
            <p>{t("docs.gettingStarted.step1Desc")}</p>
            <Link to="/datasets" className="doc-link">
              {t("docs.gettingStarted.step1Link")} →
            </Link>
          </DocStep>

          <DocStep number="2" title={t("docs.gettingStarted.step2Title")}>
            <p>{t("docs.gettingStarted.step2Desc")}</p>
            <Link to="/create-chart" className="doc-link">
              {t("docs.gettingStarted.step2Link")} →
            </Link>
          </DocStep>

          <DocStep number="3" title={t("docs.gettingStarted.step3Title")}>
            <p>{t("docs.gettingStarted.step3Desc")}</p>
          </DocStep>

          <DocStep number="4" title={t("docs.gettingStarted.step4Title")}>
            <p>{t("docs.gettingStarted.step4Desc")}</p>
            <Link to="/recommendations" className="doc-link">
              {t("docs.gettingStarted.step4Link")} →
            </Link>
          </DocStep>
        </div>

        <DocNote type="tip">
          {t("docs.gettingStarted.quickStartTip")}
        </DocNote>
      </DocSubsection>
    </DocSection>
  );
};

export default GettingStarted;
